import { Flex } from 'antd';
import PageTitle from 'components/title/title';
import { isRTL } from 'core/services/language';
import { useTranslation } from 'react-i18next';
import Icon from 'utils/icon';

function UnauthorizedComponent() {
	const { t } = useTranslation();

	return (
		<>
			<PageTitle name={t('TITLE.UNAUTHORIZED')} />

			<Flex vertical justify="center" align="center" gap={30} style={{ marginTop: 100 }}>
				<Icon name="lock" width={200} height={200} style={{ marginInlineStart: isRTL() ? -60 : 0 }} />

				<h2>{t('TITLE.UNAUTHORIZED')}</h2>

				<h4>{t('COMMON.UNAUTHORIZED_DESC')}</h4>
			</Flex>
		</>
	);
}

export default UnauthorizedComponent;
